import { ResourceTypeDto } from '@/api/generated';
import {
  resourceTypeTranslation,
  ResourceTypeTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type EmailDialogsTranslation = {
  addTask: {
    relationSearch: {
      contextResourceRequired: string;
      contextResourceType: string;
      resourceTypeOptions: ResourceTypeTranslation;
    };
  };
};

export const emailDialogsTranslation: EmailDialogsTranslation = {
  addTask: {
    relationSearch: {
      contextResourceRequired: 'Wybierz pozycję z listy',
      contextResourceType: 'Wybierz, do czego chcesz przypisać zadanie',
      resourceTypeOptions: { ...resourceTypeTranslation, [ResourceTypeDto.User]: 'Pracownik' },
    },
  },
};
